import type { IAnalyticsEventFormField } from '@sravni/cosago-react-library/lib/types';
import { useRef } from 'react';

import { useSubscribeOnCustomFormAnalyticsEvent } from 'shared/lib/useSubscribeOnAnalyticsEvent';

import styles from './SendEventWrapper.module.scss';

interface ISendEventWrapper {
  sendEvent: (arg: IAnalyticsEventFormField) => void;
}

export const SendEventWrapper: FC<ISendEventWrapper> = ({ sendEvent, children }) => {
  const formRef = useRef<HTMLDivElement | null>(null);

  useSubscribeOnCustomFormAnalyticsEvent(sendEvent, formRef.current);

  return (
    <div
      ref={formRef}
      data-qa="SendEventWrapper"
      className={styles.eventWrapper}
    >
      {children}
    </div>
  );
};
